import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  makeStyles,
  Grid,
} from "@material-ui/core";
import { ITheme } from "../constants/theme";

interface IVariant {
  Id: string;
  Title: string;
  Barcode: string;
  ImageUrl: string;
  Attributes: [string, string][];
  IsProductMixed: boolean;
}

interface IProps {
  variant: IVariant;
}

const useStyles = makeStyles((theme: ITheme) => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  media: {
    height: 160,
    backgroundSize: 'contain',
    backgroundColor: '#f5f5f5',
    margin: '12px',
  },
  content: {
    flexGrow: 1,
    padding: '12px',
  },
  title: {
    fontWeight: 600,
    marginBottom: '8px',
    lineHeight: 1.2,
    height: '2.4em',
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    fontSize: '0.9rem',
  },
  barcode: {
    color: theme.palette.text.secondary,
    marginBottom: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '0.8rem',
  },
  attributesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    marginTop: '8px',
  },
  attributeContainer: {
    backgroundColor: "rgba(158, 0, 93, 0.16)",
    paddingLeft: 6,
    paddingRight: 6,
    paddingBottom: 2,
    borderRadius: 4,
  },
  attribute: {
    color: theme.palette.primary.main,
    lineHeight: 1,
    fontWeight: 400,
    fontSize: '0.75rem',
  },
}));

export function ProductItem({ variant }: IProps) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardMedia
        className={classes.media}
        image={variant.ImageUrl}
        title={variant.Title}
      />
      <CardContent className={classes.content}>
        <Typography variant="subtitle2" component="h2" className={classes.title}>
          {variant.Title}
        </Typography>
        <Typography variant="body2" className={classes.barcode}>
          {variant.Barcode}
        </Typography>
        {variant.Attributes && variant.Attributes.length > 0 && (
          <div className={classes.attributesContainer}>
            {variant.Attributes.map(([key, value], index) => (
              <Grid item key={index} className={classes.attributeContainer}>
                <Typography variant="caption" component="span" className={classes.attribute}>
                  {`${key}: ${value}`}
                </Typography>
              </Grid>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
